export class RawData {
  datasets: Dataset[] = [];
}

export class Dataset {
  series: SeriesItem = new SeriesItem();
}

export class SeriesItem {
  query: Query;
  result: Row[];

  constructor() {
    this.query = new Query();
    this.result = [];
  }
}

export class Query {
  name: string;
  parameters: string[];
  filters: string;
  select: string;
  entity: string;
  profile: string;
  limit: number;
  orderBy: string;

  constructor() {
    this.name = '';
    this.parameters = [];
    this.select = '';
    this.entity = '';
    this.profile = '';
    this.limit = 0;
    this.orderBy = '';
    this.filters = '';
  }
}

export class Row {
  row: string[] = [];
}

/**
 * Combines the responses of single-query requests into one RawData, keeping the order of `parts`
 * so that datasets[i] still belongs to the i-th query.
 */
export function mergeRawData(parts: RawData[]): RawData {
  const merged = new RawData();
  // An empty response keeps its slot, so the indexes of the other datasets don't shift
  merged.datasets = parts.map(part => part.datasets[0] ?? new Dataset());
  return merged;
}

export class Data {
  data: string[][] = [];
}

export class ChartData {
  xAxis_categories: string[] = [];
  dataSeriesNames: string[] = [];
  dataSeriesTypes: string[] = [];
  drilldown: any = null;
  series: SeriesData[] = [];
}

class SeriesData {
  data: number[] = [];
}
